export default __webpack_public_path__ + "static/media/Wristband of the Spheres.387fe6a3.jpg";